import { FC, useEffect } from 'react';

import { useFormikContext } from 'formik';
import { UsersApi } from 'services/users/users.api';

import { IUserRegisteredAccounts } from 'interfaces/user';

import ToastService from 'helpers/ToastService';

import { IFormData, ILoginValidationProps as IProps } from './types';

export const getUsedEmailRegistrationProviders = (registeredAccounts: IUserRegisteredAccounts): string[] =>
  Object.entries(registeredAccounts).reduce((acc, [key, value]) => (value ? [...acc, key] : acc), [] as string[]);

export const EmailValidation: FC<IProps> = ({ setIsSetUpPassword }): null => {
  const { values, errors, dirty, touched } = useFormikContext<IFormData>();
  const { email: emailValue } = values;
  const { email: emailError } = errors;
  const { email: emailTouched } = touched;

  useEffect((): void => {
    const emailValidation = async () => {
      try {
        if (dirty && emailTouched && !emailError && emailValue.length !== 0) {
          const result = await UsersApi.verifyEmail({ email: emailValue });
          const usedRegistrationProviders = getUsedEmailRegistrationProviders(result.registeredAccounts);

          const isGrowexaRegistered = usedRegistrationProviders.includes('growexaInternal');
          const isSocialRegistered =
            usedRegistrationProviders.includes('faceBook') ||
            usedRegistrationProviders.includes('google') ||
            usedRegistrationProviders.includes('linkedin');

          if (!isGrowexaRegistered && isSocialRegistered) {
            return setIsSetUpPassword(true);
          }

          setIsSetUpPassword(false);
        }
      } catch (error) {
        if (error instanceof Error) {
          ToastService.showError(error.message);
          setIsSetUpPassword(false);
        }
      }
    };

    emailValidation();
  }, [emailValue, dirty, emailTouched, emailError, setIsSetUpPassword]);

  return null;
};
